import { render, staticRenderFns } from "./DetailPengiriman.vue?vue&type=template&id=a32a8e92&"
import script from "./DetailPengiriman.vue?vue&type=script&lang=js&"
export * from "./DetailPengiriman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports